import React from 'react';
import {
  DisplayContainer,
  Title,
  DocumentContent,
} from './DocumentDisplay.styles';

const DocumentDisplay = ({ document }) => {
  return (
    <DisplayContainer>
      <Title variant="h3">Document</Title>
      <DocumentContent>{document}</DocumentContent>
    </DisplayContainer>
  );
};

export default DocumentDisplay;
